import PracticeTable from "components/tables/practice/PracticeTable";
import { useState } from "react";
import Header from "pages/Header";

const AdminDashboard = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div>
      <Header collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className="claim-dashboard">
        <div className="header cd-datagrid mb-10">
          <h1>Admin Dashboard</h1>
          <button
            className="blank-hover-btn"
            onClick={() => setShowAddModal(true)}
          >
            Add Practice
          </button>
        </div>
        <div>
          <PracticeTable
            showAddModal={showAddModal}
            setShowAddModal={setShowAddModal}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
